module.exports = __webpack_public_path__ + "img/shield.3841acc0.png";